import React from 'react';
import clsx from 'clsx';

const Caret = ({ expanded }) => {
  return (
    <svg
      className={clsx(
        'h-5 w-5 shrink-0 text-slate-500 transition-transform',
        expanded ? '-rotate-90' : 'rotate-90', // ↓ cuando está colapsado, ↑ cuando está expandido
      )}
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M7.21 14.77a.75.75 0 0 1-1.06-1.06L9.44 10 6.15 6.29A.75.75 0 0 1 7.2 5.23l4.25 4.25c.29.3.29.77 0 1.06l-4.25 4.23Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default React.memo(Caret);
